import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OpenDialogAdminUserComponent } from 'app/components/dialog/open-dialog-admin-user/open-dialog-admin-user.component';
import { OpenDialogDeleteElementComponent } from 'app/components/dialog/open-dialog-delete-element/open-dialog-delete-element.component';
import { ClubDetails, CodeClub } from 'app/shared/models/class/club/club';
import { UserAdmin } from 'app/shared/models/class/user/user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UserAdminService } from 'app/shared/services/user-admin/user-admin.service';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminUsersComponent implements OnInit {

  displayedColumns: string[] = ['userName', 'lastName', 'firstName', 'role', 'email', 'actorCode', 'details'];
  dataSource!: MatTableDataSource<any>;

  valueInput!: string;
  color: ThemePalette = 'primary';
  length!: number;
  pageSize = 50;
  pageSizeOptions: number[] = [50, 100, 150];
  pageEvent!: PageEvent;
  searchForm!: UntypedFormGroup;
  role!: string;
  users: UserAdmin[] = [];
  actors: CodeClub[] = [];

  isLoading = false;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly authService: AuthService,
    private readonly tooltip: TooltipService,
    private readonly faIconService: FaiconService,
    private readonly userAdminService: UserAdminService,
    private readonly dialog: MatDialog,
    private readonly clubService: ClubService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.init();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue: any): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword')?.setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  addUser(): void {
    const params = {
      width: '450px',
      disableClose: true,
      data: { actors: this.actors }
    };
    const dialogRef = this.dialog.open(OpenDialogAdminUserComponent, params);
    dialogRef.afterClosed().subscribe((returned: any) => {
      if (returned) {
        this.users.push(returned);
        this.initDataSource(this.users, this.actors);
      }
    });
  }

  editUser(user: UserAdmin): void {
    const params = {
      width: '450px',
      disableClose: true,
      data: { actors: this.actors, user: user }
    };
    const dialogRef = this.dialog.open(OpenDialogAdminUserComponent, params);
    dialogRef.afterClosed().subscribe((returned: UserAdmin) => {
      if (returned) {
        const index = this.users.findIndex(u => u.key === user.key);
        this.users[index] = returned;
        this.initDataSource(this.users, this.actors);
      }
    });
  }

  deleteUser(user: UserAdmin): void {
    const params = {
      // width: '450px',
      disableClose: true,
      data: {
        title: `Suppression d'un utilisateur `,
        text: `Êtes-vous sûr de vouloir supprimer l'utilisateur ${user.firstName} ${user.lastName} ?`,
        id: user.key,
        action: 'deleteUserAdmin'
      }
    };
    const dialogRef = this.dialog.open(OpenDialogDeleteElementComponent, params);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.users = this.users.filter(u => u.key !== user.key);
        this.initDataSource(this.users, this.actors);
      }
    });
  }

  resetPassword(user: UserAdmin): void {
    const params = {
      disableClose: true,
      data: {
        title: `Réinitialisation du mot de passe`,
        text: `Êtes-vous sûr de vouloir réinitialiser le mot de passe de l'utilisateur ${user.firstName} ${user.lastName} ?`,
        id: user.key,
        action: 'initPassword'
      }
    };
    this.dialog.open(OpenDialogDeleteElementComponent, params);
  }

  resentInvit(user: UserAdmin): void {
    const params = {
      disableClose: true,
      data: {
        title: `Renvoyer une invitation`,
        text: `Voulez-vous renvoyer une invitaion à l'utilisateur ${user.firstName} ${user.lastName} ?`,
        id: user.key,
        action: 'initPassword'
      }
    };
    this.dialog.open(OpenDialogDeleteElementComponent, params);
  }

  private init(): void {
    this.role = this.authService.getDecodedToken()?.role;
    this.clubService.getClubs().subscribe({
      next: dataActors => {
        this.actors = dataActors;
        this.userAdminService.getByRole(this.role).subscribe({
          next: data => {
            this.users = data;
            this.isLoading = false;
            this.initDataSource(this.users, dataActors);
          }
        });
      }
    })
  }

  private initDataSource(users: UserAdmin[], actors?: CodeClub[]): void {
    users.forEach(user => {
      user.actorCode = actors?.find(actor => actor.key === user.actorKey)?.code;
    });
    this.dataSource = new MatTableDataSource(users);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

}
